// NPM Imports
import React, { Component } from "react";
import { connect } from "react-redux";
import Modal from "react-responsive-modal";
import uuid from "react-native-uuid";
import { Toastr, Button, Tooltip } from "../../../revvComponents";

// Components Imports
import AddRecipientReviewerSection from "./AddRecipientReviewerSection";

// Action Imports
import {
  addSharedDocRecipientsAction,
  fetchDocRecipientListAction,
  deleteReviewersAction,
  editReviewerPermissionAction,
  updateEmailResendAction,
} from "../../../actions/DocumentActions";

import SharedDocumentActions from "../../../actions/SharedDocumentActions";
// Services Imports

// Internal Imports
import { DocumentUtils, GlobalUtils } from "../../../utils";
import { IMAGE_URLS } from "../../../constants";
import LZLoader from "../../../commonComponents/LZLoader";

// Destructuring
const { readDataFromLocalStorage } = GlobalUtils;
const { _emailIsValid } = DocumentUtils;
const { getRecipientOfSharedDocumentAction } = SharedDocumentActions;
const { SHIELD } = IMAGE_URLS;

// DEcalarations
const RECIPIENT_DATA = {
  user_email: "",
  first_name: "",
  last_name: "",
  id: 0,
  disabled: false,
};

class SharedDocumentRecipientWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errMsg: "",
      reviewersList: [{ ...RECIPIENT_DATA }],
      sharedReviewers: [],
      reviewerEmailMessage: "",
      showLoader: false,
      showList: true,
      userOptions: [],
      sharedReviewersRecipient: [],
    };
  }

  componentDidMount() {
    this.props
      .getRecipientOfSharedDocumentAction(
        this.props.sharingHash,
        this.props.document.id,
      )
      .then(res => {
        this.setState({
          sharedReviewersRecipient: res.collaborators,
        });
      });
  }

  _showAndHideReviewerList = () => {
    this.setState(prevState => ({ showList: !prevState.showList }));
  };

  _addSignerAndRecipientList = sharedReviewers => {
    const CURRENT_USER = readDataFromLocalStorage("revvsalesUser");
    let reviewersList = [{ ...RECIPIENT_DATA, id: uuid.v4() }];
    if (CURRENT_USER) {
      const {
        id: currentUserId,
        first_name: fname,
        last_name: lname,
        user_email: email,
      } = CURRENT_USER;
      // Check if the current user is already a reviewer
      let findCurrentUser;
      if (sharedReviewers && sharedReviewers.length > 0) {
        findCurrentUser = sharedReviewers.find(
          recp => recp.user && recp.user.id === currentUserId,
        );
      }
      // Check if the current user is already a signer
      if (!findCurrentUser && sharedReviewers && sharedReviewers.length === 0) {
        reviewersList = [
          {
            user_email: email,
            first_name: fname,
            last_name: lname,
            role: "Reviewer",
            id: uuid.v4(),
            disabled: false,
          },
          {
            ...RECIPIENT_DATA,
            id: uuid.v4(),
          },
        ];
      }
    }
    this.setState({
      reviewersList,
      sharedReviewers,
      showLoader: false,
    });
  };

  _addUserToTheList = () => {
    this.setState(prevState => {
      const cloneReviewerList = [...prevState.reviewersList];
      cloneReviewerList.push({
        ...RECIPIENT_DATA,
        id: uuid.v4(),
      });
      return { reviewersList: cloneReviewerList, errMsg: "" };
    });
  };

  _removeReviewer = index => {
    const data = [...this.state.reviewersList];
    data.splice(index, 1);
    this.setState(() => ({ reviewersList: data, errMsg: "" }));
  };

  // get users from the state for the validation
  _getUserStateData = email => {
    let stateUser = null;
    let stateUserIndex = null;
    for (let i = 0; i < this.state.reviewersList.length - 1; i += 1) {
      if (this.state.reviewersList[i].user_email === email) {
        stateUser = email;
        stateUserIndex = i;
      }
    }
    return { stateUser, stateUserIndex };
  };

  // Handle dynamic  Fields
  _handleValue = (eventData, i, name) => {
    const data = [...this.state.reviewersList];
    if (name === "user_email") {
      if (eventData === null) {
        data[i].disabled = false;
        data[i][name] = "";
        data[i].id = 0;
        data[i].first_name = "";
        data[i].last_name = "";
        this.setState({
          errMsg: "",
        });
      } else {
        data[i].disabled = false;
        data[i][name] = eventData.label;
        data[i].id = 0;
        data[i].first_name = "";
        data[i].last_name = "";
        if (
          eventData.label.length > 0 &&
          _emailIsValid(eventData.label) === false
        ) {
          data[i].notValid = true;
        } else {
          delete data[i].notValid;
          const { stateUser, stateUserIndex } = this._getUserStateData(
            eventData.label,
          ); // Get the user & it's index from state of current entered user
          // Get the user from already shared reviewers

          // const addedSignerList = this.state.signersList
          //   ? this.state.signersList.find(item => item.user_email === email)
          //   : null;
          // Case 1. if user exists in state "reviewersList"
          if (this.state.sharedReviewersRecipient) {
            const alreadySharedUser = this.state.sharedReviewersRecipient.find(
              usr => usr.user.user_email === eventData.label,
            );
            if (alreadySharedUser) {
              data[i].disabled = true;
              data[i].id = alreadySharedUser.user.id;
              data[i].first_name = alreadySharedUser.user.first_name;
              data[i].last_name = alreadySharedUser.user.last_name;
              this.setState({ errMsg: "" });
            }
          }
          if (stateUser && stateUserIndex !== i) {
            data[i].disabled = true;
            this.setState({
              errMsg:
                "You've already added this contact as a recipient. Please click on the (x) button to clear the field and add a new one.",
              // isEdit: false,
            });
          } else if (
            this.state.userOptions &&
            this.state.userOptions.length > 0
          ) {
            const findUser = this.state.userOptions.find(
              usr => usr.user_email === eventData.label,
            );
            if (findUser) {
              data[i].disabled = true;
              data[i].id = findUser.id;
              data[i].first_name = findUser.first_name;
              data[i].last_name = findUser.last_name;
              this.setState({ errMsg: "" });
            }
          }
        }
      }
    } else {
      data[i][name] = eventData.target.value;
    }
    this.setState(() => ({ reviewersList: data }));
  };

  _removeAddedReviewer = reviewerId => {
    this.setState(
      prevState => {
        let cloneSharedReviewers = prevState.sharedReviewers;
        cloneSharedReviewers = cloneSharedReviewers.filter(
          recp => recp.user.id !== reviewerId,
        );
        return { sharedReviewers: cloneSharedReviewers };
      },
      () => {
        this._onRemoveUser(reviewerId);
      },
    );
  };

  _onRemoveUser = reviewerId => {
    const { document } = this.props;
    this.props
      .deleteReviewersAction(document.id, reviewerId)
      .then(() => {
        Toastr.showToastr({
          type: "success",
          message: "Access to this document successfully revoked for teammate.",
          timeout: 3000,
        });
      })
      .catch(err => {
        console.error(err);
        Toastr.showToastr({
          type: "failure",
          message: "Oops! Something went wrong. Please try again later.",
          timeout: 3000,
        });
      });
  };

  _closePopup = () => {
    this.props.updateMultipleState({
      showDocumentForwarding: false,
    });
  };

  _getShareDocumentPayload = () => {
    const { reviewersList } = this.state;
    const collaborators = [];
    if (reviewersList.length > 0) {
      reviewersList.forEach((reviewer, i) => {
        const tempObj = {
          is_editable: reviewer.is_editable,
          user_email: reviewer.user_email,
          first_name: reviewer.first_name,
          last_name: reviewer.last_name,
          recipientId: i + 1,
        };
        if (i === reviewersList.length - 1) {
          if (tempObj.user_email && tempObj.first_name && tempObj.last_name) {
            collaborators.push({ ...tempObj });
          }
        } else {
          collaborators.push({ ...tempObj });
        }
      });
    }
    const data = {
      collaborators: [...collaborators],
      isReview: true,
      emailSubject: this.state.reviewerEmailMessage,
    };
    data.docName = this.props.document.name;
    return data;
  };

  _onSendDocument = () => {
    const payload = this._getShareDocumentPayload();
    this.setState({ showbtnLoader: true });
    this.props
      .addSharedDocRecipientsAction(
        this.props.document.id,
        this.props.sharingHash,
        payload,
      )
      .then(() => {
        this.props.updateMultipleState({
          sucessPopup: true,
          showDocumentForwarding: false,
        });
      })
      .catch(err => {
        this.setState({ showbtnLoader: false, showLoader: false });
        console.error(err);
        Toastr.showToastr({
          type: "failure",
          message: "Oops! Something went wrong. Please try again later.",
          timeout: 3000,
        });
      });
  };

  _handleSendForSignature = () => {
    this.props.updateMultipleState({
      showAddRecipientsPopup: false,
      showDocStatusUpdateModal: true,
    });
  };

  _changeReviewMessage = e => {
    this.setState({ reviewerEmailMessage: e.target.value });
  };

  _checkFormValidation = isSubmitBtn => {
    const { reviewersList } = this.state;
    let isValid = true;
    if (reviewersList && reviewersList.length > 0) {
      reviewersList.forEach((user, index) => {
        const { user_email: e, first_name: fn, last_name: ln } = user;
        if (e === "" || !_emailIsValid(e) || fn === "" || ln === "") {
          isValid = false;
        }
        if (
          isSubmitBtn &&
          reviewersList &&
          reviewersList.length > 1 &&
          reviewersList.length - 1 === index &&
          e === "" &&
          fn === "" &&
          ln === ""
        ) {
          isValid = true;
        }
      });
    } else if (isSubmitBtn) {
      isValid = false;
    }
    return isValid;
  };

  render() {
    const {
      reviewersList,
      showLoader,
      showbtnLoader,
      reviewerEmailMessage,
      sharedReviewers,
      userOptions,
    } = this.state;
    // const { docRecipientList } = this.props;
    const errMsgSpace =
      this.state.errMsg !== "" ? (
        <div
          className="error-message-wrapper docsharingpopup-errormg-wrapper"
          data-test="doc-sharing-popup-error-message">
          {this.state.errMsg}
        </div>
      ) : null;

    let isBtnDisable = false;

    if (
      reviewersList &&
      reviewersList.length > 0 &&
      (reviewersList[0].user_email === "" ||
        reviewersList[0].first_name === "" ||
        reviewersList[0].last_name === "" ||
        reviewersList[0].notValid === true)
    ) {
      isBtnDisable = true;
    } else if (sharedReviewers && sharedReviewers.length === 0) {
      isBtnDisable = !this._checkFormValidation(true);
    }
    return (
      <Modal open onClose={this._closePopup} center closeOnOverlayClick={false}>
        {/* ----------- Loader Section ----------- */}
        {(showLoader || showbtnLoader) && (
          <LZLoader
            className="loader-bg-color"
            label={` ${showbtnLoader ? "Please wait..." : "Loading..."}`}
          />
        )}
        <div className="docrecipientspopup-container">
          {/* ----------- Modal Heading Section ----------- */}
          <div
            className="modal-heading"
            data-test="addrecipientspopup-modal-heading">
            Recipient Details
          </div>

          {errMsgSpace}

          {/* ----------- Added Signer List Section ----------- */}
          {/* {signersList && signersList.length > 0 && (
            <SignerListSection signersList={signersList} />
          )} */}

          <div className="docsharingpopup-sharingform-title">
            The following people will receive an email with the document link
          </div>

          <div className="addrecipientspopup-reviewers-section">
            {/* ----------- Add Reviewer List Section ----------- */}
            <AddRecipientReviewerSection
              reviewersList={reviewersList}
              addUserToTheList={this._addUserToTheList}
              handleValue={this._handleValue}
              removeReviewer={this._removeReviewer}
              checkFormValidation={this._checkFormValidation}
              userOptions={userOptions}
            />
            <div className="docsharing-reviewer-email">
              <p className="docsharing-reviewer-email-subheading">
                Add a message for your recipients
              </p>
              <textarea
                rows="5"
                value={reviewerEmailMessage}
                onChange={e => this._changeReviewMessage(e)}
                data-test="addrecipientspopup-textarea"
                placeholder="Start typing your message here"
              />
            </div>
            {/* ----------- Added  Reviewer List Section  ----------- */}
          </div>
          <div className="emptysigner-popup-warning-section">
            <div>
              <img src={SHIELD} alt="Revv" className="legal-signer-icon" />
            </div>
            <div>
              <div className="emptysigner-popup-legal-title">
                Legal, secure, reliable
              </div>
              <div className="emptysigner-popup-legal-subtitle">
                The Revv eSignature Service has been designed to produce
                electronic signatures that are legally binding under applicable
                U.S. law.
              </div>
            </div>
          </div>

          {/* ----------- Modal Footer Section ----------- */}
          <div className="modal-footer">
            <Button
              type="five"
              id="addrecipientspopup-cancle-btn"
              className="btn btn-transparent modal-footer-btn cancle-btn"
              data-test="addrecipientspopup-cancle-btn"
              onClick={this._closePopup}>
              Cancel
            </Button>
            {isBtnDisable ? (
              <Tooltip
                placement="bottom"
                align={{
                  offset: [0, 4],
                }}
                overlay="Add recipient details to send document">
                <div className="tooltip-allowed">
                  <Button
                    type="four"
                    id="addrecipientspopup-share-btn"
                    className="btn btn-primary modal-footer-btn submit-btn"
                    data-test="addrecipientspopup-share-btn"
                    disabled={isBtnDisable}
                    isLoading={showbtnLoader}
                    onClick={this._onSendDocument}>
                    Send document
                  </Button>
                </div>
              </Tooltip>
            ) : (
              <Button
                type="four"
                id="addrecipientspopup-share-btn"
                className="btn btn-primary modal-footer-btn submit-btn"
                data-test="addrecipientspopup-share-btn"
                isLoading={showbtnLoader}
                onClick={this._onSendDocument}>
                Send document
              </Button>
            )}
          </div>
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  // ! IMP::
  // * IN ASSEST PAGE THERE IS AN OPTION TO SHARE THE DOCUMENT, TO HANDLE THAT CASE THIS TERNIARY OPERATOR LOGIC IS USED.
  // * NOW THE DATA NEEDED FOR THIS COMPONENT CAN EITHER BE FETCHED FROM REDUX OR SENT FROM PARENT COMPONENT
  // * SINCE AMPLITUDE NEEDS SOME ADDITIONAL DOCUMENT DATA INSTEAD OF JUST THE DOC ID THIS APPROACH WAS TAKEN

  const { document: documentDataFromRedux, docRecipientList } =
    state.DocumentStore;
  const { document: documentDataFromParent, fromAssetPage } = ownProps;

  const document = fromAssetPage
    ? documentDataFromParent
    : documentDataFromRedux;
  return {
    document,
    docRecipientList,
  };
};

const mapDispatchToProps = {
  addSharedDocRecipientsAction,
  fetchDocRecipientList: fetchDocRecipientListAction,
  deleteReviewersAction,
  editReviewerPermissionAction,
  updateEmailResendAction,
  getRecipientOfSharedDocumentAction,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SharedDocumentRecipientWrapper);
